import { NeutralColors } from '@fluentui/react';
import { ErrorCircleFilled, FluentIcon } from '@fluentui/react-icons';
import React, { CSSProperties } from 'react';
import useToast from '../../utils/hooks/useToast';

const iconMap: Record<string, FluentIcon> = {
  ErrorBadge: ErrorCircleFilled,
};

const toastContainerStyle: CSSProperties = {
  position: 'absolute',
  top: 76,
  right: 45,
  zIndex: 9999,
};

const toastIconStyle: CSSProperties = { fontSize: 16, alignSelf: 'center', marginRight: 8 };
const toastIconContainerStyle: CSSProperties = { display: 'flex', paddingBottom: 4 };
const toastItemContainerStyle: CSSProperties = {
  marginBottom: 16,
  maxWidth: 320,
  background: NeutralColors.white,
};
const toastItemWrapperStyle: CSSProperties = {
  paddingTop: 12,
  paddingBottom: 12,
  marginLeft: 32,
  marginRight: 32,
};
const toastItemContentStyle: CSSProperties = { fontWeight: 400 };
const toastItemHeaderStyle: CSSProperties = { fontWeight: 600 };

const ToastContainer = (): JSX.Element => {
  const { toasts } = useToast();

  return (
    <div
      style={toastContainerStyle}
      role="region"
      aria-label="Notifications"
      aria-live="polite"
      aria-relevant="additions"
      aria-atomic="false"
    >
      {toasts?.map((toast) => {
        const IconComponent = toast?.iconName ? iconMap[toast.iconName] : null;

        return (
          <div
            key={toast?.id}
            className={`ms-depth-4  ms-motion-duration-4 ${
              toast?.className ?? 'ms-motion-slideUpIn'
            }`}
            style={toastItemContainerStyle}
          >
            <div style={toastItemWrapperStyle}>
              <div style={toastIconContainerStyle}>
                {IconComponent ? (
                  <span style={toastIconStyle}>
                    <IconComponent />
                  </span>
                ) : null}
                <strong style={toastItemHeaderStyle}>{toast?.header}</strong>
              </div>
              <div style={toastItemContentStyle}>{toast?.content}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ToastContainer;
